<template>
    <loader v-if="loading" />
    <v-row v-else>
        <v-col>
            <v-card>
                <v-card-title>Beskrivelse</v-card-title>
                <v-divider />
                <v-card-text>{{ campaign.description }}</v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card>
                <v-card-title>Pitch</v-card-title>
                <v-divider />
                <v-card-text>{{ campaign.pitch }}</v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: [
        'uniqueId'
    ],
    data () {
        return {
            loading: false,
            campaign: null
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get(`campaigns/${this.uniqueId}`)
            this.campaign = response.data
            this.loading = false
        }
    },
    created () {
        this.getData()
    }
}
</script>